















































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NewsletterWidget extends Vue {
  @Prop({ type: String, default: 'Newsletter' }) readonly title!: string
  @Prop({ type: Array, default: () => ['MORNING'] }) readonly lists!: string[]

  protected selectedLists: string[] = []
  private response: any = null
  private email: string = ''
  private submitted: boolean = false

  private listMapping: any = [
    {
      id: 'MORNING',
      title: 'NEUE täglich informiert',
      subtitle: 'Di-Sa um 06:00 Uhr',
    },
    {
      id: 'WEEKEND',
      title: 'NEUE am Sonntag',
      subtitle: 'Sonntag um 06:00 Uhr',
    },
  ]

  get availableLists() {
    return this.listMapping.filter((list: any) => this.lists.includes(list.id))
  }

  get status() {
    if (!this.response) {
      return null
    }

    return this.response.data.subscribeNewsletter.success
      ? 'Anmeldung erfolgreich'
      : 'Anmeldung fehlgeschlagen'
  }

  mounted() {
    this.selectedLists = this.availableLists.map((list: any) => list.id)
  }

  async subscribe(): Promise<void> {
    this.submitted = true
    this.response = null
    const mutation = require('~base/graphql/mutations/SubscribeNewsletter.gql')
    const apolloClient = this.$apolloProvider.defaultClient

    try {
      this.response = await apolloClient.mutate({
        mutation,
        variables: {
          email: this.email,
          lists: this.selectedLists,
        },
      })
    } catch (e) {
      this.response = {
        data: {
          subscribeNewsletter: {
            success: false,
          },
        },
      }
    }
  }

  toggleList(list: any) {
    if (this.selectedLists.includes(list.id)) {
      this.selectedLists = this.selectedLists.filter(
        (id: string) => id !== list.id
      )
    } else {
      this.selectedLists.push(list.id)
    }
  }
}
